<template>
    <ReactPage>
        <account-status-report-page></account-status-report-page>
    </ReactPage>
</template>

<script>
import ReactPage from '../components/ReactPage.vue';

export default {
    name: "AccountStatusReport",
    components: {
        ReactPage
    }
}
</script>